var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_detail_page" },
    [
      _c("div", { staticClass: "header" }, [_vm._v("用户详情")]),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "30px",
            "padding-left": "50px",
            width: "100%",
            "min-height": "300px",
          },
        },
        [
          _c("div", { staticStyle: { width: "50%", float: "left" } }, [
            _c("p", { staticClass: "user_detail_msg" }, [
              _vm._v("姓名：" + _vm._s(_vm.msg.name)),
            ]),
            _c("p", { staticClass: "user_detail_msg" }, [
              _vm._v("头像：" + _vm._s(_vm.msg.pic)),
            ]),
            _c("p", { staticClass: "user_detail_msg" }, [
              _vm._v("职业：" + _vm._s(_vm.msg.professional)),
            ]),
            _c("p", { staticClass: "user_detail_msg" }, [
              _vm._v("城市：" + _vm._s(_vm.msg.city)),
            ]),
            _c("p", { staticClass: "user_detail_msg" }, [
              _vm._v("状态：" + _vm._s(_vm.msg.status)),
            ]),
          ]),
          _vm._m(0),
        ]
      ),
      _c("p", { staticClass: "table_title" }, [_vm._v("绑定设备数：")]),
      _c("a-table", {
        staticStyle: { "margin-top": "20px" },
        attrs: { columns: _vm.columns, "data-source": _vm.data },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { width: "50%", float: "left" } }, [
      _c("p", { staticClass: "user_detail_msg" }, [_vm._v("性别：")]),
      _c("p", { staticClass: "user_detail_msg" }, [_vm._v("ID：")]),
      _c("p", { staticClass: "user_detail_msg" }, [_vm._v("联系邮箱：")]),
      _c("p", { staticClass: "user_detail_msg" }, [_vm._v("创建时间：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }